export {
    ConversationalMMAnalyticsEvent,
    type ConversationalMMAnalyticsEventName,
    type ConversationalMMTrackEvent,
} from './src/analytics/events';
export * from './src/constants';
export {
    ConversationalMMEmbeddedResults,
    type ConversationalMMEmbeddedResultsProps,
} from './src/embedded/ConversationalMMEmbeddedResults';
export { adjustMoneyMapForHighBills } from './src/hooks/useGetRuleSets';
export { type TerminalSlideAction } from './src/types';
export { getAhaMomentImageSource } from './src/utils/ahaMomentImages';
export {
    buildStaticRuleSetDisplays,
    computeRuleSetDisplays,
    getPrimaryRuleDescription,
    GOAL_DATE_CUTOFF_YEARS,
    type RuleSetDisplayResult,
} from './src/utils/simulationDisplayUtils';

// ConversationalMMFullscreenResults is intentionally NOT re-exported here —
// it statically imports react-native-gesture-handler/react-native-safe-area-context,
// which grove-app does not install. Consumers that need it (member-app)
// import it directly:
//   import { ConversationalMMFullscreenResults } from '@fruitful/conversational-mm/src/fullscreen/ConversationalMMFullscreenResults';
